import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-create-edit',
  templateUrl: './services-create-edit.component.html',
  styleUrls: ['./services-create-edit.component.scss']
})
export class ServicesCreateEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  close() {
    
  }

}
